import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Card, Input } from '@monigo/ui';
import { supabase } from '../../lib/supabase.js';
import { useState } from 'react';
import { AuthLayout } from '../../components/Layout/AuthLayout.js';

export function ConfirmPendingPage() {
  const { t } = useTranslation();
  const [resending, setResending] = useState(false);
  const [resentEmail, setResentEmail] = useState<string | null>(null);

  return (
    <AuthLayout
      title={t('auth.confirmPendingTitle')}
      subtitle={t('auth.confirmPendingBody')}
      backTo="/signup"
    >
      <div className="space-y-5">
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-[1.75rem] bg-accent text-4xl text-white shadow-[0_18px_35px_hsl(var(--color-accent)/0.22)]">
            ✉
          </div>
          <h1 className="text-4xl font-display font-extrabold text-text">
            {t('auth.confirmPendingTitle')}
          </h1>
          <p className="mt-3 text-base leading-7 text-text-muted">{t('auth.confirmPendingBody')}</p>
        </div>

        <Card className="p-5 md:p-6">
          <form
            className="flex flex-col gap-4"
            onSubmit={async (e) => {
              e.preventDefault();
              const fd = new FormData(e.currentTarget);
              const email = String(fd.get('email') ?? '').trim();
              if (!email) return;
              setResending(true);
              await supabase.auth.resend({ type: 'signup', email });
              setResending(false);
              setResentEmail(email);
            }}
          >
            <label className="flex flex-col gap-2 text-sm">
              <span className="font-semibold text-text">{t('auth.email')}</span>
              <Input name="email" type="email" required placeholder="name@example.com" />
            </label>
            <Button type="submit" isLoading={resending} className="w-full">
              {t('auth.resendConfirm')}
            </Button>
            {resentEmail ? (
              <p className="rounded-[1.25rem] bg-success/10 p-4 text-center text-sm text-success">
                ✓ {t('auth.resetSent')}
              </p>
            ) : null}
          </form>
        </Card>

        <p className="text-center text-sm text-text-muted">
          <Link to="/login" className="font-semibold text-primary">
            {t('auth.loginCta')}
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
}
